import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, Button, Skeleton } from '@mui/material';
import { NotFound } from '../layout/SystemState';
import { getRun } from '../../services/runService';
import AssignLessons from './AssignLessons';
import AdasRunWizard from './AdasRunWizard';

// /runs/:runId/setup: an imported run assigns its lessons (YES-259); an ADAS run adds lessons with
// their people (YES-267)
const RunSetup = () => {
    const { runId } = useParams();
    const [kind, setKind] = useState(null);
    const [status, setStatus] = useState('loading');

    const load = useCallback(async () => {
        setStatus('loading');
        try {
            setKind((await getRun(runId)).kind);
            setStatus('ready');
        } catch (err) {
            setStatus(err.response?.status === 404 ? 'notFound' : 'error');
        }
    }, [runId]);
    useEffect(() => { load(); }, [load]);

    if (status === 'notFound') return <NotFound />;
    if (status === 'error') {
        return (
            <Box sx={{ maxWidth: 600, mx: 'auto', mt: 6 }}>
                <Alert severity="error" action={<Button color="inherit" size="small" onClick={load}>Try again</Button>}>Couldn’t load the run.</Alert>
            </Box>
        );
    }
    if (status === 'loading') return <Box sx={{ maxWidth: 1200, mx: 'auto' }}><Skeleton width={320} height={56} /><Skeleton variant="rounded" height={360} /></Box>;
    return kind === 'adas' ? <AdasRunWizard mode="setup" /> : <AssignLessons />;
};

export default RunSetup;
